import { gql } from '@apollo/client';

// TODO: Clean these up and make a clearer hierarchy

export const AIRLINE_BASIC_FRAGMENT = gql`
  fragment AirlineBasic on Airline {
    id
    name
    shortname
    nameCoalesced
    iataCode
    icaoCode
    callsign
  }
`;

export const AIRLINE_DETAIL_FRAGMENT = gql`
  fragment AirlineDetail on Airline {
    ...AirlineBasic
    homeLink
    wikipediaLink
    aliases
  }
  ${AIRLINE_BASIC_FRAGMENT}
`;

export const AIRLINE_COMPACT_FRAGMENT = gql`
  fragment AirlineCompact on Airline {
    id
    nameCoalesced
    iataCode
    icaoCode
  }
`; 